import { Card, ThemeProvider } from "@mui/material";
import { keepPreviousData } from "@tanstack/react-query";
import LoadingScreen from "components/loading/LoadingScreen";
import Table from "components/table/Table";
import {
  ALL_OPTION,
  LIST_OUTBOUND_CALL_STATUS_V2,
  TYPE_PBX_OPTIONS,
} from "constant";
import { usePagination } from "hooks/usePagination";
import moment from "moment";
import ReportDetailFailedOutboundCallFilter from "pages/reports/report-detail-failed-outbound-call/components/ReportDetailFailedOutboundCallFilter";
import { useMemo, useState } from "react";
import {
  useExportDetailFailedOutboundCall,
  useGetDetailFailedOutboundCall,
} from "service/query/report.query";
import muiTheme from "theme/muiTheme";

const ReportDetailFailedOutboundCall = () => {
  const [filter, setFilter] = useState(null);
  const { data: detailFailedOutboundCall, isFetching } =
    useGetDetailFailedOutboundCall(
      {
        ...filter,
      },
      {
        enabled: !!filter,
        placeholderData: keepPreviousData,
      }
    );
  const {
    page,
    pageSize,

    handleChangePage,
    handleChangePageSize,
    clientData,
    clientTotal,
  } = usePagination(detailFailedOutboundCall);

  const handleSubmit = (values) => {
    const from = moment(values.dateRange[0]).toISOString();
    const to = moment(values.dateRange[1]).toISOString();

    // Ban đầu ALL nên tất cả giá trị value = null
    // Check chỉ gửi điều kiện nhỏ nhất lên
    let valueCityCode = null;
    let valueDistrict = null;
    let valueSubOrg = null;

    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district === ALL_OPTION.value &&
      values.subOrg === ALL_OPTION.value
    ) {
      valueCityCode = values.cityCode;
    }
    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district !== ALL_OPTION.value &&
      values.subOrg === ALL_OPTION.value
    ) {
      valueDistrict = values.district;
    }

    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district !== ALL_OPTION.value &&
      values.subOrg !== ALL_OPTION.value
    ) {
      valueSubOrg = values.subOrg;
    }

    setFilter({
      toNumber: values.toNumber || null,
      ladingCode: values.ladingCode || null,

      cityCode: valueCityCode,
      district: valueDistrict,
      subOrg: valueSubOrg,

      typePbx: values.typePbx === ALL_OPTION.value ? null : values.typePbx,
      fromNumber: values.fromNumber || null,
      callStatusCode:
        values.callStatusCode === ALL_OPTION.value
          ? null
          : values.callStatusCode,
      extension: values.extension || null,
      from,
      to,
    });

    handleChangePage(1);
  };

  const columns = useMemo(
    () => [
      {
        id: "citycode",
        name: "Mã BĐT",
      },
      {
        id: "cityname",
        name: "Tên BĐT",
      },
      {
        id: "provincecode",
        name: "Mã BC",
      },
      {
        id: "provincename",
        name: "Tên Bưu cục",
      },
      {
        id: "ext",
        name: "Số máy lẻ",
        render: (record) => {
          return record.ext?.name || "_";
        },
      },
      {
        id: "user",
        name: "Người gọi ra",
        render: (record) => {
          return record.user?.fullname || "_";
        },
      },
      {
        id: "from",
        name: "Đầu số gọi ra",
      },
      {
        id: "startedAt",
        name: "Thời gian gọi ra",
        type: "datetime",
      },
      {
        id: "to",
        name: "Số thuê bao nhận",
      },
      {
        id: "ladingCode",
        name: "Số hiệu bưu gửi",
      },
      {
        id: "network",
        name: "Loại mạng của người nhận",
        type: "network",
      },

      {
        id: "callStatus",
        name: "Trạng thái cuộc gọi",
        render: (record) =>
          LIST_OUTBOUND_CALL_STATUS_V2.find(
            (item) => item.value === record.callStatus
          )?.label,
      },

      {
        id: "typePbx",
        name: "Loại tổng đài",
        render: (record) =>
          TYPE_PBX_OPTIONS.find((item) => item.value === record.typePbx)?.label,
      },
      {
        id: "pnsCallStatusCode",
        name: "Mã Lỗi Tổng đài trả về",
      },
    ],
    []
  );

  // const { refetch: handleExport, isFetching: isFetchingExport } =
  //   useExportDetailFailedOutboundCall(filter, null, modalExportHistories.openModal);
  const { refetch: handleExport, isFetching: isFetchingExport } =
    useExportDetailFailedOutboundCall(
      {
        ...filter,
        isExport: true,
      },
      { enabled: false }
    );

  return (
    <ThemeProvider theme={muiTheme}>
      <Card sx={{ mb: 2 }}>
        <ReportDetailFailedOutboundCallFilter
          onSubmit={handleSubmit}
          onExport={handleExport}
          isDisabledExport={!filter}
        />
      </Card>

      <Card>
        <Table
          columns={columns}
          data={clientData}
          toolbar={{
            title: "Báo cáo chi tiết cuộc gọi ra lỗi",
          }}
          pagination={{
            page,
            pageSize,
            totalItems: clientTotal,
            onPageChange: handleChangePage,
            onPageSizeChange: handleChangePageSize,
          }}
        />
      </Card>

      <LoadingScreen loading={isFetching || isFetchingExport} />
    </ThemeProvider>
  );
};

export default ReportDetailFailedOutboundCall;
